module.exports = {
	WAITING: 0,
	RUNNING: 1,
	AD_REQUESTING_RUNNING: 2, // Headerbid-less ad-request initiated but still waiting auction for second request
	AD_REQUESTING: 3,
	DONE: 4,
};
